import React, { useEffect, useRef } from 'react';
import { canvasContainerId } from '../../../canvas';
import { useDebouncedCallback } from '@mantine/hooks';
import { navContainerId } from '../../../navbar/NavBar';

const useCalcFlowContainerHeght = (isFoldFlow, defH) => {
  const canvasContainer = useRef(null);
  const navOffsetTop = useRef(0);
  useEffect(() => {
    const navContainer = document.getElementById(navContainerId);
    navOffsetTop.current = navContainer.getBoundingClientRect().bottom;
    resizePage();
    window.addEventListener('resize', resizePage);
    return () => {
      window.removeEventListener('resize', resizePage);
    };
  }, [defH, isFoldFlow]);

  const resizePage = useDebouncedCallback(() => {
    if (isFoldFlow) {
      canvasContainer.current = document.getElementById(canvasContainerId);
      canvasContainer.current.style.height = window.innerHeight - navOffsetTop.current + 'px';
    } else {
      canvasContainer.current = document.getElementById(canvasContainerId);
      canvasContainer.current.style.height = window.innerHeight - navOffsetTop.current - defH + 'px';
    }
  }, 200);
};
export default useCalcFlowContainerHeght;
